import * as types from '../Actions/types';
import { categories } from '../../Components/CreateForm/types';

let defaultCTAData = [{actionLabel: "submit", actionName: "Submit", arabicActionLabel: "يقدم", arabicActionName: "تقديم الطلب"}, {actionLabel: "saveasdraft", actionName: "Save as draft", arabicActionLabel: "حفظ كمسودة", arabicActionName: "حفظ كمسودة"}];

const INIT_STATE = {
    meta: {},
    fieldData: {},
    data: [],
    actions: defaultCTAData,
    editServiceCard: {},
    serviceCards: [],
    categories: categories
};

const Form = (state = INIT_STATE, action) => {
    switch(action.type){
        case types.INIT_LOGOUT:
            return INIT_STATE;

        case types.FORM_META_DATA:
            return{
                ...state,
                meta: action.data
            }

        case types.ADD_FIELD_DATA:
            return {
                ...state,
                fieldData: action.data,
                data: (action.data && action.data.defaultField) ? [action.data, ...state.data] : [...state.data, action.data]
            }

        case types.EDIT_FIELD_DATA:
            let updateData = (state.data.length > 0) ? state.data.map((data, index) => (index === action.id) ? {...data, ...action.data} : {...data}) : [];
            return {
                ...state,
                data: updateData
            }
                
        case types.DELETE_FIELD_DATA:
            let newData = (state.data.length > 0) ? state.data.filter(({name}) => name !== action.data.name) : [];
            return {
                ...state,
                data: newData
            }

        case types.REARRANGE_FIELD_DATA:
            return {
                ...state,
                data: action.data
            }

        case types.CREATE_WORKFLOW_ACTION:
            let stateData = state.actions;
            let oldData = stateData.filter(({actionName}) => actionName === action.data.actionName).length === 0;
            let checkDup = (action.data.actionName && oldData) ? [...stateData, action.data] : defaultCTAData;
            return {
                ...state,
                actions: checkDup
            }

        case types.EDIT_WORKFLOW_ACTION:
            let actionID = action.id;
            let actionData = action.data;
            let editedData = state.actions.map((action, index) => (index === actionID) ? {...actionData} : action);
            return {
                ...state,
                actions: editedData
            }

        case types.DELETE_WORKFLOW_ACTION:
            return {
                ...state,
                actions: (state.actions.length > 0) ? state.actions.filter(({actionName}) => actionName !== action.name) : []
            }

        case types.SERVICE_CARD_DATA:
            let insertData = (action.data.length >= 1);
            return {
                ...state,
                serviceCards: insertData ? [...action.data] : []
            }

        case types.CREATE_SERVICE_CARD:
            let existingServiceCard = state.serviceCards.map((serviceCard, index) => 
                (index === action.data.id) ? { title: action.data.title, description: action.data.description, arabicTitle: action.data.arabicTitle, arabicDescription: action.data.arabicDescription }
            : serviceCard);
            return {
                ...state,
                serviceCards: (action.data.id !== '') ? existingServiceCard : (action.data.title ? [...state.serviceCards, action.data] : [])
            }

        case types.EDIT_SERVICE_CARD:
            return {
                ...state,
                editServiceCard: action.data
            }

        case types.REARRANGE_SERVICE_CARD:
            return {
                ...state,
                serviceCards: action.data
            }

        case types.DELETE_SERVICE_CARD:
            return {
                ...state,
                serviceCards: (state.serviceCards.length > 0) ? state.serviceCards.filter(({title}) => title !== action.title) : []
            }

        case types.CREATE_CATEGORY:
            let existingCategory = state.categories.map((category, index) => (index === action.data.id) ? action.data : category);
            return {
                ...state,
                categories: (action.data.length > 1) ? action.data : ((action.data.id) ? existingCategory : (action.data.label ? [...state.categories, action.data] : categories))
            }

        case types.EDIT_CATEGORY:
            return {
                ...state,
                editServiceCard: action.data
            }

        case types.DELETE_CATEGORY:
            return {
                ...state,
                categories: (state.categories.length > 0) ? state.categories.filter(({label}) => label !== action.title) : categories
            }

        default:
            return state;
    }
};

export default Form;